"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Highimpactcommandcta() {
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: captionRef,
    isVisible: captionVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  return <section data-section-id="4535" id="join-cta" className="bg-background text-foreground relative w-full overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/secure_digital_infrastructure.webp)]" />

      {}
      <div className="absolute inset-0" style={{
      background: "linear-gradient(135deg, hsla(221, 40%, 4%, 0.9) 0%, hsla(221, 30%, 15%, 0.7) 50%, hsla(221, 40%, 4%, 0.8) 100%)"
    }} />

      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.08] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      <div className="relative z-10 mx-auto flex max-w-[800px] flex-col items-center px-6 py-32 text-center md:py-44 lg:py-[180px]">
        {}
        <div ref={labelRef} className={`mb-12 transition-all duration-700 ease-out md:mb-16 ${labelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="font-default text-xs tracking-[0.25em] text-white/90 uppercase">
            05 — Secure
          </span>
        </div>

        {}
        <h2 ref={headingRef} className={`font-default font-bold text-white leading-[0.95] tracking-tight transition-all duration-1000 ease-out ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        fontSize: "clamp(3.5rem, 10vw, 8.75rem)"
      }}>
          Fortify your
          <span className="inline-flex items-center px-3 align-middle md:px-5">
            <span className="inline-block h-[1px] bg-primary" style={{
            width: "clamp(2.5rem, 6vw, 5rem)",
            transform: "rotate(-20deg)"
          }} />
          </span>
          digital presence.
        </h2>

        {}
        <p ref={bodyRef} className={`mt-10 max-w-[560px] text-base leading-relaxed text-white/80 transition-all duration-1000 delay-150 ease-out md:text-xl ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        fontFamily: "var(--font-default)"
      }}>
          Every connection starts with a commitment to privacy. Share your security requirements and operational goals — we will provide a tailored protection strategy within two business days.
        </p>

        {}
        <div ref={ctaRef} className={`mt-12 flex flex-col items-center gap-6 transition-all duration-1000 delay-300 ease-out sm:flex-row sm:gap-8 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Button asChild size="lg" className="group h-auto rounded-lg bg-primary px-8 py-4 text-base font-medium text-white shadow-lg hover:bg-primary/90">
            <Link to="https://vpngenix.com/go/NordVPN" newTab>
              Start Your Protection
              <ArrowRight className="ml-1 size-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>

          <Link to="/CybersecurityCyberGenixPage" className="group inline-flex items-center gap-2 border-b border-white/40 pb-1 text-sm font-medium tracking-wide text-white transition-colors hover:border-white">
            Explore Solutions
            <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>

        {}
        <p ref={captionRef} className={`mt-16 font-default text-[11px] tracking-[0.2em] text-white/60 uppercase transition-all duration-1000 delay-500 ease-out md:text-xs ${captionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          Rapid Deployment — 48 Hours / Global Secure Network
        </p>
      </div>
    </section>;
}